import type { DatasetSyncUpdatedEvent } from '@databox/types/domains/ai/pusher.types';

import type { APIData } from 'webapp-types';

import type { DataSourceSyncStatus } from 'webapp/models/source';

import { SourcesPusherEvents } from 'webapp/services/model-manager/sources';

/** The raw sync status last relayed per dataset (space access id). */
export type RelayedSyncStatuses = Map<number, DataSourceSyncStatus>;

/**
 * The dataset whose sync status a sync-status bgEvent changed, for Genie's dataset card to refetch;
 * null for any other bgEvent, or for a status already relayed for that dataset. account-management
 * repeats `PARTIAL_SYNC` on every progress tick of one sync, so only a change is relayed; the card's
 * state itself comes from ai-bff, which folds the status.
 */
export function getDatasetSyncUpdate(
	data: APIData.App.BgEvent,
	relayedStatuses: RelayedSyncStatuses,
): DatasetSyncUpdatedEvent | null {
	const { origin, spaceAccessId, syncStatus } = data;

	if (origin !== SourcesPusherEvents.SOURCE_SYNC_STATUS_UPDATED || !spaceAccessId) {
		return null;
	}

	if (syncStatus === undefined || relayedStatuses.get(spaceAccessId) === syncStatus) {
		return null;
	}

	relayedStatuses.set(spaceAccessId, syncStatus);

	return { spaceAccessId };
}
